<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    setTopbarControls: {
      type: Function,
      required: true
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
      this.setTopbarControls(null);
    }
  }
};
</script>
<template>
  <div class="d-flex font-size-12 h-75">
    <i @click="$router.go(-1)" class="ri-arrow-left-line text-primary btn my-auto font-size-20 pl-0 py-0"
    ></i>
    <div class="d-flex align-items-center justify-content-between">
      <h2 class="mb-0 font-size-32 text-primary">{{title}}</h2>
    </div>
  </div>
</template>